import React, { useState, useEffect } from "react";
import MainButton from "./MainButton";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Paper,
  Button,
  TextField,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

/* Левый блок с таблицей */
const MainLeft = ({
  setResponseListChannels,
  setSendDataFilmListQueryFilter,
}) => {
  // Состояния для каждого Select
  const [selectedFormat, setSelectedFormat] = useState("3");
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState([]);
  const [selectedLastShow, setSelectedLastShow] = useState("");
  const [selectedRate, setSelectedRate] = useState("");
  const [selectedVote, setSelectedVote] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedPreset, setSelectedPreset] = useState("");
  const [textFilter, setTextFilter] = useState("");
  const [excludeCountry, setExcludeCountry] = useState(false);
  const [excludeGenre, setExcludeGenre] = useState(false);

  // // Массив данных для селектов
  // const selectFormat = [];
  // const selectCountry = [];
  // const selectGenre = [];
  // const selectLastShow = [];
  // const selectRate = [];
  // const selectVote = [];
  // const selectYear = [];
  // const selectPreset = [];

  // Массив данных для отправки в API как фильтр
  // отправка в виде &country=1|2|3&genre=1|2|3&last_show=
  const [sendFilterToAPI, setSendFilterToAPI] = useState("");
  const [filters, setFilters] = useState({
    format: "",
    country: "",
    genre: "",
    last_show: "",
    rate: "",
    vote: "",
    year: "",
    query: "",
    CountryBlackList: false,
    GenreBlackList: false,
    preset: "",
  });

  const updateFilter = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value, // Обновляем только конкретный параметр
    }));

    // После обновления фильтров, создаем строку параметров
    setSendFilterToAPI(() => {
      const updatedFilters = {
        ...filters, // Сначала используем текущие фильтры
        [key]: value, // Обновляем только измененный фильтр
      };

      // Преобразуем объект фильтров в строку параметров
      const filterString = Object.keys(updatedFilters)
        .filter((filterKey) => updatedFilters[filterKey]) // Исключаем пустые значения
        .map((filterKey) => `${filterKey}=${updatedFilters[filterKey]}`) // Собираем строку параметров
        .join("&"); // Соединяем их в строку

      return filterString ? `&${filterString}` : ""; // Добавляем & перед первым параметром
    });
  };

  // // Заполняем массивы данными
  // if (responseFilter.format) {
  //   responseFilter.format.map((element) => {
  //     selectFormat.push({ value: element.id, label: element.name });
  //   });
  // }
  // if (responseFilter.country) {
  //   responseFilter.country.map((element) => {
  //     selectCountry.push({ value: element.id, label: element.name });
  //   });
  // }
  // if (responseFilter.genre) {
  //   responseFilter.genre.map((element) => {
  //     selectGenre.push({ value: element.id, label: element.name });
  //   });
  // }
  // if (responseFilter.last_show) {
  //   responseFilter.last_show.map((element) => {
  //     selectLastShow.push({ value: element.id, label: element.name });
  //   });
  // }
  // if (responseFilter.rate) {
  //   responseFilter.rate.map((element) => {
  //     selectRate.push({ value: element.id, label: element.name });
  //   });
  // }
  // if (responseFilter.vote) {
  //   responseFilter.vote.map((element) => {
  //     selectVote.push({ value: element.id, label: element.name });
  //   });
  // }
  // if (responseFilter.year) {
  //   responseFilter.year.map((element) => {
  //     selectYear.push({ value: element.id, label: element.name });
  //   });
  // }
  // if (responseFilter.preset) {
  //   responseFilter.preset.map((element) => {
  //     selectPreset.push({ value: element.id, label: element.name });
  //   });
  // }

  // Обработчики изменений для каждого Select
  const handleChangeFormat = (e) => {
    const value = e.target.value;
    const format = value === "" ? "" : selectedFormat === value ? "" : value;

    setSelectedFormat(format);
    updateFilter("format", format);
  };
  const handleChangeCountry = (event) => {
    const value = event.target.value; // массив выбранных значений
    setSelectedCountry(value);

    // Объединяем выбранные элементы в строку с |
    const joinedValue = value.join("|");
    updateFilter("country", joinedValue);
  };

  const handleChangeGenre = (e) => {
    const value = e.target.value;
    setSelectedGenre(value);
    const joinedValue = value.join("|");
    updateFilter("genre", joinedValue);
  };
  const handleChangeLastShow = (e) => {
    const value = e.target.value;
    const lastShow =
      value === "" ? "" : selectedLastShow === value ? "" : value;
    setSelectedLastShow(lastShow);
    updateFilter("last_show", lastShow);
  };
  const handleChangeRate = (e) => {
    const value = e.target.value;
    const newRate = value === "" ? "" : selectedRate === value ? "" : value;

    setSelectedRate(newRate);
    updateFilter("rate", newRate);
  };
  const handleChangeVote = (e) => {
    const value = e.target.value;
    const newVote = value === "" ? "" : selectedVote === value ? "" : value;
    setSelectedVote(newVote);
    updateFilter("vote", newVote);
  };
  const handleChangeYear = (e) => {
    const value = e.target.value;
    const newYears = value === "" ? "" : selectedYear === value ? "" : value;
    setSelectedYear(newYears);
    updateFilter("year", newYears);
  };
  const handleChangePreset = (e) => {
    const value = e.target.value;
    const newPreset = value === "" ? "" : selectedPreset === value ? "" : value;
    setSelectedPreset(newPreset);
    updateFilter("preset", newPreset);
  };
  // Обработчик изменений в поле "Название/часть названия"
  const handleQueryChange = (event) => {
    const query = event.target.value;
    setTextFilter(query);
    updateFilter("query", query);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      ButtonOnClick();
    }
  };

  const ButtonOnClick = () => {
    const timestamp = new Date().getTime().toString();
    // Добавляем временную метку к запросу
    const updatedFilter = `${sendFilterToAPI}&timestamp=${timestamp}`;
    setSendDataFilmListQueryFilter(updatedFilter);
  };

  useEffect(() => {
    // if (selectedFormat) {
    //   updateFilter("format", selectFormat[2].value);
    // }
  }, []);

  const handleExcludeCountryChange = (event) => {
    const isChecked = event.target.checked;
    updateFilter("CountryBlackList", isChecked);
  };

  const handleExcludeGenreChange = (event) => {
    const isChecked = event.target.checked;
    updateFilter("GenreBlackList", isChecked);
  };
  return (
    <Box
      sx={{
        width: "15%", // Ширина левого блока — 15% от экрана
        minWidth: "330px",
        borderRight: "1px solid #ddd",
        height: "100%", // Высота — на всю страницу
        padding: 1,
        boxSizing: "border-box",
      }}
    >
      <Typography variant="h6" align="center" gutterBottom>
        Поиск по названию
      </Typography>
      <TableContainer component={Paper} sx={{ maxHeight: "calc(100% - 40px)" }}>
        <Table>
          <TableBody sx={{ border: "1px solid #ccc" }}>

            <TableRow>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", gap: 2 }}
              >
                <Typography variant="body1">Название/часть названия</Typography>
                <TextField
                  sx={{ width: "200px" }}
                  variant="outlined"
                  value={textFilter} // Привязываем значение к состоянию textFilter
                  onChange={handleQueryChange} // Обрабатываем изменение значения
                  onKeyDown={handleKeyDown}
                  InputProps={{
                    sx: {
                      height: "30px", // Устанавливаем общую высоту поля
                      padding: 0, // Убираем padding для уменьшения высоты
                      "& input": {
                        padding: "0 8px", // Устанавливаем padding для текста внутри поля
                        height: "20px", // Высота внутреннего input
                        fontSize: "14px", // Можно дополнительно уменьшить размер текста, если нужно
                      },
                    },
                  }}
                />
              </Box>
            </TableRow>
            <TableRow>
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ButtonOnClick}
                >
                  сформировать
                </Button>
              </Box>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

    </Box>
  );
};

export default MainLeft;
